import { useContext } from "react";
import GlobalContext from "../contexts/global.context";

export default () => useContext( GlobalContext );